import { gql } from '@apollo/client';

export const SEND_WHATSAPP_TEST = gql`
  mutation sendWhatsAppTest($input: WhatsAppTestInput!) {
    sendWhatsAppTest(input: $input)
  }
`;

export const BROADCAST_WHATSAPP = gql`
  mutation broadcastWhatsApp($input: WhatsAppBroadcastInput!) {
    broadcastWhatsApp(input: $input) {
      id
      templateName
      status
      totalRecipients
      sent
      skipped
      failed
      dryRun
      error
      createdAt
      finishedAt
    }
  }
`;

export const CANCEL_WHATSAPP_BROADCAST = gql`
  mutation cancelWhatsAppBroadcast($id: ID!) {
    cancelWhatsAppBroadcast(id: $id) {
      id
      status
    }
  }
`;

export const SEND_WHATSAPP_TEST_MESSAGE = gql`
  mutation sendWhatsAppTestMessage($input: WhatsAppTestMessageInput!) {
    sendWhatsAppTestMessage(input: $input) {
      sid
      sender
      status
      delivered
      errorCode
      explanation
    }
  }
`;
